import { HKDSE_MATHS_MC_2004 } from './HKDSE-Maths-MC-2004';
import { HKDSE_MATHS_MC_2005 } from './HKDSE-Maths-MC-2005';
import { HKDSE_MATHS_MC_2006 } from './HKDSE-Maths-MC-2006';
import { HKDSE_MATHS_MC_2007 } from './HKDSE-Maths-MC-2007';
import { HKDSE_MATHS_MC_2008 } from './HKDSE-Maths-MC-2008';
import { HKDSE_MATHS_MC_2009 } from './HKDSE-Maths-MC-2009';
import { HKDSE_MATHS_MC_2010 } from './HKDSE-Maths-MC-2010';
import { HKDSE_MATHS_MC_2012 } from './HKDSE-Maths-MC-2012';
import { HKDSE_MATHS_MC_2013 } from './HKDSE-Maths-MC-2013';
import { HKDSE_MATHS_MC_2014 } from './HKDSE-Maths-MC-2014';
import { HKDSE_MATHS_MC_2015 } from './HKDSE-Maths-MC-2015';
import { HKDSE_MATHS_MC_2016 } from './HKDSE-Maths-MC-2016';
import { HKDSE_MATHS_MC_2017 } from './HKDSE-Maths-MC-2017';
import { HKDSE_MATHS_MC_2018 } from './HKDSE-Maths-MC-2018';
import { HKDSE_MATHS_MC_2019 } from './HKDSE-Maths-MC-2019';



// All available past papers
export const PAST_PAPERS_DATA = {
  2004: HKDSE_MATHS_MC_2004,
  2005: HKDSE_MATHS_MC_2005,
  2006: HKDSE_MATHS_MC_2006,
  2007: HKDSE_MATHS_MC_2007,
  2008: HKDSE_MATHS_MC_2008,
  2009: HKDSE_MATHS_MC_2009,
  2010: HKDSE_MATHS_MC_2010,
  2012: HKDSE_MATHS_MC_2012,
  2013: HKDSE_MATHS_MC_2013,
  2014: HKDSE_MATHS_MC_2014,
  2015: HKDSE_MATHS_MC_2015,
  2016: HKDSE_MATHS_MC_2016,
  2017: HKDSE_MATHS_MC_2017,
  2018: HKDSE_MATHS_MC_2018,
  2019: HKDSE_MATHS_MC_2019
};

// Available years
export const AVAILABLE_YEARS = Object.keys(PAST_PAPERS_DATA).map(year => parseInt(year)).sort((a, b) => b - a);

// Get paper by year
export const getPaperByYear = (year) => {
  return PAST_PAPERS_DATA[year] || null;
};

// Get all topics across all papers
export const getAllTopics = () => {
  const topicsSet = new Set();
  Object.values(PAST_PAPERS_DATA).forEach(paper => {
    paper.topics.forEach(topic => topicsSet.add(topic));
  });
  return Array.from(topicsSet).sort();
};

// Get questions by topic across all papers
export const getQuestionsByTopic = (topic) => {
  const questions = [];
  Object.values(PAST_PAPERS_DATA).forEach(paper => {
    paper.questions.forEach(question => {
      if (question.topic === topic) {
        questions.push({
          ...question,
          year: paper.year,
          paperTitle: paper.title
        });
      }
    });
  });
  return questions;
};

// Get questions by difficulty
export const getQuestionsByDifficulty = (difficulty) => {
  const questions = [];
  Object.values(PAST_PAPERS_DATA).forEach(paper => {
    paper.questions.forEach(question => {
      if (question.difficulty === difficulty) {
        questions.push({
          ...question,
          year: paper.year,
          paperTitle: paper.title
        });
      }
    });
  });
  return questions;
};

// Search questions by keyword
export const searchQuestions = (keyword) => {
  const questions = [];
  const searchTerm = keyword.toLowerCase();
  
  Object.values(PAST_PAPERS_DATA).forEach(paper => {
    paper.questions.forEach(question => {
      if (
        question.question.toLowerCase().includes(searchTerm) ||
        question.topic.toLowerCase().includes(searchTerm) ||
        question.solution.toLowerCase().includes(searchTerm)
      ) {
        questions.push({
          ...question,
          year: paper.year,
          paperTitle: paper.title
        });
      }
    });
  });
  
  return questions;
};

// Get paper statistics
export const getPaperStatistics = () => {
  return Object.values(PAST_PAPERS_DATA).map(paper => ({
    year: paper.year,
    title: paper.title,
    totalQuestions: paper.totalQuestions,
    timeLimit: paper.timeLimit,
    statistics: paper.statistics
  }));
}; 